import InfoField from '../InfoField';
import ConfirmPriceCheckbox from '../ConfirmPriceCheckbox';
import PiezasList from '../PiezasList';
import { formatFecha, sumPrecioVentaPiezas } from '../../utils';

const RecambistaBusquedaView = ({
    alternativa,
    piezas = [],
    confirmPrice,
    onConfirmPriceChange,
    onCopyPiezaUrl,
}) => {
    const hasMultiplePiezas = piezas.length > 1;
    const hasPiezas = piezas.length > 0;
    const piezasLabel = hasMultiplePiezas
        ? 'Piezas alternativa'
        : 'Pieza alternativa';
    const precioVentaTotal =
        alternativa?.precio_venta_nuevo ?? sumPrecioVentaPiezas(piezas);

    return (
        <>
            <div className="row g-3 mb-3">
                <div className="col-md-6">
                    <InfoField
                        label="Fecha presupuesto"
                        value={formatFecha(alternativa?.fecha)}
                    />
                </div>
                <div className="col-md-6">
                    <InfoField
                        label="Cliente"
                        value={alternativa?.cliente ?? '-'}
                    />
                </div>
                <div className="col-md-12">
                    <InfoField
                        label={piezasLabel}
                        value={
                            hasPiezas ? (
                                <PiezasList
                                    piezas={piezas}
                                    variant="alternativa"
                                    onCopyPiezaUrl={onCopyPiezaUrl}
                                    precioVentaTotal={precioVentaTotal}
                                />
                            ) : (
                                '-'
                            )
                        }
                    />
                </div>
            </div>
            <ConfirmPriceCheckbox
                checked={confirmPrice}
                onChange={onConfirmPriceChange}
            />
        </>
    );
};

export default RecambistaBusquedaView;
